import { useMemo } from 'react';
import { useResourceList } from '../../engine/api/hooks';
import { Stat } from '../../engine/design/primitives/Misc';

// CSAT tile: average score + response count over the loaded responses, rendered in the CSAT
// list's toolbar (ScreenDef action component). Scores are 1–5 integers, so the maths is plain.

export function CsatTile() {
  const list = useResourceList<{ score: number }>('csat', { sort: '-created_at' }, { limit: 200 });
  const { avg, n, promoters } = useMemo(() => {
    const scores = list.rows.map((r) => Number(r.score)).filter((s) => Number.isFinite(s));
    const n = scores.length;
    const avg = n ? scores.reduce((a, b) => a + b, 0) / n : null;
    const promoters = n ? Math.round((scores.filter((s) => s >= 4).length / n) * 100) : null;
    return { avg, n, promoters };
  }, [list.rows]);
  return (
    <div className="hf-stats" aria-label="CSAT summary">
      <Stat label="Average score" value={avg == null ? '—' : `${avg.toFixed(1)} / 5`} sub={`${n} response${n === 1 ? '' : 's'}`} icon="sparkles" accent />
      <Stat label="Satisfied (4–5)" value={promoters == null ? '—' : `${promoters}%`} icon="check-circle" />
    </div>
  );
}
